import {  MARK_OFFER_PROVIDED,  REMOVE_OFFER_DATA} from './actionTypes';


export const markOfferProvided = (offer: string) => {
    return {
        type: MARK_OFFER_PROVIDED,
        offer,
    };
};


export const removeOfferData = (offerName: string) => {
    return {
        type: REMOVE_OFFER_DATA,
        offerName,
    };
};






// WEBPACK FOOTER //
// ./modules/launch-offers-appevent-utility/actions/actions.ts